<template>
  <div class="home">
    <div class="card">
      <div class="title">KYC online verification</div>
      <div class="input_box">
        <div class="box_title">CPF de 11 bits</div>
        <input type="number" v-model="bankObj.cpf" placeholder="CPF de 11 bits">
        <div class="warnContent" v-show="haveContent">
          <van-icon name="warning" /><span class="red">CPF campo não pode estit vazl </span>
        </div>
        <div class="warnTip">
          Lembrete: Os bancos brasileiros exigem que você preencha o CPF de pagamento real e o nome real para recarregar
          normalment
        </div>
      </div>
      <div class="input_box">
        <div class="box_title">Nome</div>
        <input type="text" v-model="bankObj.name" placeholder="Nome">
        <div class="warnContent" v-show="haveContent1">
          <van-icon name="warning" /><span class="red">o campo de nome nÃo pode estar vazio </span>
        </div>
        <div class="warnTip">
          Por favor, preencha corretamente: o nome real da conta de pagamento para estepedido para garantir um recibo
          normal
        </div>
      </div>
      <div class="btn" @click="sumbit_en">Enviar</div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Fetch from "../../utils/fetch";
import { Icon } from "vant";
Vue.use(Icon);


// import countTo from "vue-count-to";


export default {
  name: "Index",
  components: {
  },
  data() {
    return {
      bankObj: {
        cpf: "",
        name: "",
        uid: "",
        origin: "",
      },
      haveContent: false,
      haveContent1: false
    };
  },
  watch: {

  },
  created() {
    // console.log(window.parent.frames.location.href);

    this.bankObj.uid = this.$route.query.uid;
    this.bankObj.origin = this.$route.query.origin;
  },
  mounted() {
    // window.onload = function () {
    //   let iframe = document.getElementById('myiframe');
    //   console.log(iframe, '123232323232666')
    //   let src = iframe.getAttribute("src");
    //   console.log(src, '123123')
    // }
    // document.domain = 'example.com'
    let iframeUrl = window.self.location.href;
    this.bankObj.uid = this.GetQueryString("uid");
    this.bankObj.origin = this.GetQueryString("origin");
    console.log(iframeUrl)
  },
  methods: {
    sumbit_en() {
      console.log(this.bankObj)
      if (this.bankObj.cpf == "") {
        this.haveContent = true
        return
      } else {
        this.haveContent = false
      }
      if (this.bankObj.name == "") {
        this.haveContent1 = true
        return
      } else {
        this.haveContent1 = false
      }
      Fetch("/pay/userSave", this.bankObj).then((r) => {
        if (r.code == 1) {
           this.$message({
            message: r.msg,
            type: "success",
          });
          console.log(55555)
          window.parent.location.reload()
          // window.top.location.reload()
        } else {
          return this.$message({
            message: r.msg,
            type: "error",
          });
        }
      })
    },
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]); return null;
    }
  }
};
</script>
<style lang="less" scoped>
// @import "./assets/css/variables.less";
@primary-color: #151D29; //头部颜色
@secondary-color: #1d2533; //模块颜色（如pc端模块背景色）
@third-color: #293544; //高亮色取laftnav里的模块背景色
@anttextcolor: #fff0bb; //副色调如黄色 红色等
@textcolor1: #55657E; //取登录的图标颜色
@textcolor2: #d9ffe7; //暂时弃用
@textcolor3: #55657e; //ft的字体颜色
@textcolorf: #ffffff; //预留备用 dark 变light 才需要变
@bodercolor: #55657E; //边框色
@popupcolor: #151d29; //弹出层颜色
@popupTextColor: #ADB6C4; //弹出层字体颜色
@maxWidth: 420px; //最大宽度
@gradientColorStar: #55657E; //渐变开始颜色
@gradientColorEnd: #1d2533; //渐变结束颜色
@rechargeColor: #ebc96f; //充值页面高亮
@disableColor: #999999;
@svgColor: #FFFFFF;
@activityColor: #263244;
@jiaoColor: #FF0F0F;
@ButtonColor: #EBC96F;
@vipBacColor: #04BE02;
@vipTextColor: #937f4c;
@vipTextMoneyColor: #263244;
@textcolor4: #ffb800;

/deep/ .van-icon-warning {
  font-size: .55rem;
  color: #fd4843;
}

.warnContent {
  margin-top: .2rem;
}

.red {
  margin-left: .3rem;
  color: #fd4843;
  font-size: .44rem;
  line-height: .7rem;
}

.warnTip {
  margin-top: .1rem;
  margin-bottom: .4rem;
  line-height: .7rem;
}

.title {
  color: #fff;
  font-size: .5rem;
  font-weight: 900;
  text-align: center;
  margin-bottom: 1rem;
}

.card {
  width: 100%;
  height: 19.5rem;
  overflow-y: scroll;
  background-color: @primary-color;
  // margin-top: 3rem;
  border-top-left-radius: .5rem;
  border-top-right-radius: .5rem;
  padding: .8rem .5rem;
  box-sizing: border-box;
  font-family: sans-serif;
  // color: @textcolor5;
  color: @textcolor1;
  font-size: .45rem;
  margin: 0 auto;
  // margin-top: 1rem;

  .input_box {
    box-sizing: border-box;

    .box_title {
      color: #fff;
    }

    input {
      box-sizing: border-box;
      width: 100%;
      background-color: @third-color;
      border: none;
      padding: .3rem .5rem;
      border-radius: .2rem;
      margin-top: .2rem;
      // margin-bottom: .4rem;
      color: #fff;
    }

    select {
      box-sizing: border-box;
      width: 100%;
      background-color: @popupcolor;
      border: none;
      padding: .3rem .5rem;
      border-radius: .2rem;
      margin-top: .2rem;
      margin-bottom: .4rem;
      color: #fff;
      font-size: .45rem;

      option {
        max-width: 100%;
      }
    }
  }

  .btn {
    // background: linear-gradient(to right, @userFirColor, @indexBcColor, @userFirColor);
    height: 1rem;
    margin-top: 1rem;
    border-radius: .5rem;
    text-align: center;
    line-height: 1rem;
    // color: @profitWeColor;
    background-color: #fef1bb;
    color: #151d29;
    font-size: .4rem;
    font-weight: 700;
  }
}
</style>